import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setNetworkError } from '@/shared/store/slices/appSlice';
import AppNavbar from '@/components/layout/AppNavbar';
import Footer from '@/components/layout/Footer';

function ServerErrorPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleRetry = () => {
    dispatch(setNetworkError(false));
    window.location.reload();
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <AppNavbar guestMode />
      <main className="container-lg nav-padding-guest">
        <div className="text-center py-5">
          <FontAwesomeIcon icon={["fas", "server"]} className="text-primary mb-4 fs-36" />
          <h3 className="mb-3">{t('server_error_title')}</h3>
          <p className="text-muted mb-4">{t('server_error_description')}</p>
          <button className="btn btn-primaryF rounded-pill" onClick={handleRetry}>
            <FontAwesomeIcon icon={["fas", "rotate-right"]} className="me-2" />
            {t('server_error_retry')}
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ServerErrorPage;
